<style>
.v-data-table-mobile-row {
    min-height: 32px;
}
</style>
<template>
    <v-container fluid id="my--visits">
        <v-row class="background: secondary">
            <v-container fluid style="max-width: 960px;">
                <v-col class="caption" cols="12">{{ $t('Filtr pro zobrazení') }}</v-col>
                <v-chip-group v-model="filter" column multiple class="mt-n2 mb-2">
                    <v-chip filter value="associated" color="primary">{{ $t('Včetně přidružených') }}</v-chip>
                </v-chip-group>
            </v-container>
        </v-row>
        <v-container fluid style="max-width: 960px;">
            <v-data-table
                    item-key="visitId"
                    :loading="loading"
                    :headers="headers"
                    :items="items"
                    :sort-by="sortBy"
                    sort-desc="true"
                    class="mt-4 mb-4">
                <template v-slot:item.endTime="{ item }">{{ item.endTime | moment('D.M.Y HH:mm:ss') }}</template>
                <template v-slot:item.timeLength="{ item }">{{ item.timeLength | timeLength }}</template>
                <template v-slot:item.reservation="{ item }">{{
                    item.reservation ? item.reservation.name : '-'
                    }}
                </template>
                <template v-slot:item.totalSum="{ item }">{{ item.totalSum | currency }}</template>
                <template v-slot:item.creditAfter="{ item }">{{ item.creditAfter | currency }}</template>
            </v-data-table>
        </v-container>
        <!--    <v-row class="background: grey lighten-1">-->
        <!--      <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--        <v-alert type="info" color="grey lighten-1">{{ $t('Zde najdete přehled svých návštev') }}</v-alert>-->
        <!--      </v-container>-->
        <!--    </v-row>-->
        <!--    <div v-if="this.items.length > 0">-->
        <!--      <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--        <v-data-table item-key="establishment" :loading="loading" :headers="sumHeaders" :items="groupedVisits"-->
        <!--                      class="mt-4 mb-4">-->
        <!--          <template v-slot:item.establishment="{ item }">-->
        <!--            {{ item.establishment ? item.establishment.establishmentName : '-' }}-->
        <!--          </template>-->
        <!--          <template v-slot:item.totalTime="{ item }">{{ item.totalTime | timeLength }}</template>-->
        <!--          <template v-slot:item.totalPrice="{ item }">{{ item.totalPrice | currency }}</template>-->
        <!--        </v-data-table>-->
        <!--      </v-container>-->
        <!--      <v-row class="background: grey lighten-1">-->
        <!--        <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--          <v-alert type="info" color="grey lighten-1">{{ $t('Zde najdete sumární přehled svých návštev') }}</v-alert>-->
        <!--        </v-container>-->
        <!--      </v-row>-->
        <!--    </div>-->
    </v-container>
</template>
<script>
import DisplayGroupMixin from '@/mixins/display-group-mixin'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
    props: {
        visits: {
            type: Array,
            default: null
        }
    },
    mixins: [DisplayGroupMixin, TransformMixin],
    data() {
        return {
            search: null,
            filter: [],
            summaryData: 0,
            establishmentType: '',
            sortBy: ['endTime', 'card.displayedCardNo', 'reservation', 'entryEstablishment.establishmentName'],
            headers: [{
                text: 'Provoz',
                value: 'entryEstablishment.establishmentName',
                searchable: true,
                sortable: true
            }, {
                text: 'Karta/Lístek',
                value: 'card.displayedCardNo',
                searchable: true,
                sortable: true
            }, {
                text: 'Datum ukončení',
                value: 'endTime',
                sortable: true
            }, {
                text: 'Délka',
                value: 'timeLength'
            }, {
                text: 'Pronájem',
                value: 'reservation'
            }, {
                text: 'Cena',
                value: 'totalSum'
            }, {
                text: 'Zůstatek',
                value: 'creditAfter'
            }],
            sumHeaders: [{
                text: 'Provoz',
                value: 'establishment'
            }, {
                text: 'Karta/Lístek',
                value: 'cardNo'
            }, {
                text: 'Počet',
                value: 'totalCount'
            }, {
                text: 'Celkový čas',
                value: 'totalTime'
            }, {
                text: 'Celková cena',
                value: 'totalPrice'
            }],
        }
    },
    computed: {
        loading() {
            return this.visits === null
        },
        items() {
            return this.visits !== null ? this.visits.filter(item => this.customFilter(item)) : []
        },
        totalCount() {
            return this._sumForKey('totalCount')
        },
        totalTime() {
            return this._sumForKey('totalTime')
        },
        totalPrice() {
            return this._sumForKey('totalPrice')
        },
        allEstablishments() {
            var es = []
            for (var i = 0; i < this.items.length; i++) {
                var establishment = this.items[i]['entryEstablishment']['establishmentName']
                var found = false
                for (var j = 0; !found && j < es.length; j++) {
                    found = establishment === es[j]
                }
                if (!found) {
                    es.push(establishment)
                }
            }
            return es
        },
        allCards() {
            var cs = []
            for (var i = 0; i < this.items.length; i++) {
                var cNo = this.items[i]['card']['cardNo']
                if (cNo !== null && cNo !== undefined && cNo.length > 0) {
                    var found = false
                    for (var j = 0; !found && j < cs.length; j++) {
                        found = cNo === cs[j]
                    }
                    if (!found) cs.push(cNo)
                }
            }
            return cs
        },
        groupedVisits() {
            var gvs = []
            for (var i = 0; i < this.items.length; i++) {
                var v = this.items[i]
                var theGv = null
                for (var j = 0; theGv === null && j < gvs.length; j++) {
                    var gv = gvs[j]
                    if (gv.establishment.establishmentName === v.entryEstablishment.establishmentName &&
                        v.card.displayedCardNo === gv.cardNo) {
                        theGv = gv
                    }
                }
                if (theGv === null) {
                    theGv = {}
                    theGv.establishment = v.entryEstablishment
                    theGv.cardNo = v.card !== null ? v.card.displayedCardNo : null
                    theGv.totalTime = 0
                    theGv.totalPrice = 0
                    theGv.totalCount = 0
                    gvs.push(theGv)
                }
                theGv.totalTime += v.timeLength
                theGv.totalPrice += v.totalSum
                theGv.totalCount++
            }
            gvs.sort(function (a, b) {
                var valA = a.establishment.establishmentName
                var valB = b.establishment.establishmentName
                var val = 0
                if (valA < valB) {
                    val = -1
                }
                if (valA > valB) {
                    val = 1
                }
                if (val === 0) {
                    valA = a.card !== null ? a.cardNo : 'Z'
                    valB = b.card !== null ? b.cardNo : 'Z'
                    if (valA < valB) {
                        val = -1
                    }
                    if (valA > valB) {
                        val = 1
                    }
                }
                return val
            })
            return gvs
        }
    },
    methods: {
        customFilter(item) {
            return this.isCreditedCard(item)
        },
        isCreditedCard(item) {
            return this.filter.includes('associated') || item.card === null || item.card.creditCardId === null
        },
        _sumForKey(key) {
            var size = this.groupedVisits ? this.groupedVisits.length : 0
            var sum = 0
            for (var i = 0; i < size; i++) {
                sum += parseInt(this.groupedVisits[i][key])
            }
            return sum
        }
    }
}
</script>
